export default function Home() {
    return (
        <h2>
            Search for a city to get started
        </h2>
    )
}